<div id="member-statements-container">
  <div class="page-header">
    <app-toolbar-options icon="text_snippet">
      <div class="d-flex flex-column" slot="start">
        <div class="page-title">View Statements</div>

      </div>
    </app-toolbar-options>
  </div>
  <div class="page-content" appanimatecss>

   <app-component-wrapper fragmentid="insurance_questionnaire" icon="content_copy" title="Document list" >
      <div class="d-flex flex-column" slot="start">
        <app-member-document-viewer category="member-statements"></app-member-document-viewer>
      </div>
    </app-component-wrapper>
 <!--
    <app-component-wrapper fragmentid="insurance_details" icon="admin_panel_settings" title="Your insurance cover" >
      <div class="d-flex flex-column" slot="start">
        <app-insurance-details></app-insurance-details>
      </div>
    </app-component-wrapper> -->

  </div>
</div>
